import React, { useEffect, useState } from "react";
import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Switch,
    FormControlLabel,
} from "@mui/material";

import {
    createEmployeeSlotPlan,
    getEmployeeSlotPlans,
} from "../../../Servicefile/employeeSlotPlanService";
import "./EmployeeSlotPlanPage.css";


const EmployeeSlotPlanPage = () => {
    const [plans, setPlans] = useState([]);

    const [open, setOpen] = useState(false);

    const [formData, setFormData] = useState({
        id: 0,
        slotPrice: "",
        freeEmployeeLimit: "",
        active: true,
    });

    useEffect(() => {
        loadPlans();
    }, []);

    const loadPlans = async () => {
        try {
            const response = await getEmployeeSlotPlans();
            setPlans(response);
        } catch (error) {
            console.log(error);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const savePlan = async () => {
        try {
            await createEmployeeSlotPlan(formData);

            setOpen(false);

            setFormData({

                slotPrice: "",
                freeEmployeeLimit: "",
                active: true,
            });

            loadPlans();
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <div style={{ padding: 20 }}>
            <div className="employee-slot-container">

                <div
                    style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        width: "100%",
                        marginBottom: "20px"
                    }}
                >
                    <Button
                        variant="contained"
                        onClick={() => setOpen(true)}
                        sx={{
                            backgroundColor: "#ff790d",
                            textTransform: "none",
                            fontWeight: 600,
                            borderRadius: "8px",
                            padding: "8px 18px",
                            "&:hover": {
                                backgroundColor: "#e66c00",
                            },
                        }}
                    >
                        + Add Plan
                    </Button>
                </div>

                <div className="table-wrapper">

                    <table className="employee-slot-table">

                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Slot Price (₹)</th>
                                <th>Free Employee Limit</th>
                                <th>Status</th>
                            </tr>
                        </thead>

                        <tbody>
                            {plans?.length > 0 ? (
                                plans.map((item) => (
                                    <tr key={item.id}>
                                        <td>{item.id}</td>

                                        <td>₹ {item.slotPrice}</td>

                                        <td>{item.freeEmployeeLimit}</td>

                                        <td>
                                            <span
                                                className={
                                                    item.active
                                                        ? "status-active"
                                                        : "status-inactive"
                                                }
                                            >
                                                {item.active ? "Active" : "Inactive"}
                                            </span>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td
                                        colSpan="4"
                                        className="no-data"
                                    >
                                        No Employee Slot Plans Found
                                    </td>
                                </tr>
                            )}
                        </tbody>

                    </table>

                </div>

            </div>

            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle>Add Employee Slot Plan</DialogTitle>

                <DialogContent>

                    <TextField
                        fullWidth
                        margin="normal"
                        label="Slot Price"
                        name="slotPrice"
                        value={formData.slotPrice}
                        onChange={handleChange}
                    />

                    <TextField
                        fullWidth
                        margin="normal"
                        label="Free Employee Limit"
                        name="freeEmployeeLimit"
                        value={formData.freeEmployeeLimit}
                        onChange={handleChange}
                    />

                    <FormControlLabel
                        control={
                            <Switch
                                checked={formData.active}
                                onChange={(e) =>
                                    setFormData({
                                        ...formData,
                                        active: e.target.checked,
                                    })
                                }
                            />
                        }
                        label="Active"
                    />
                </DialogContent>

                <DialogActions>
                    <Button
                        onClick={() => setOpen(false)}
                    >
                        Cancel
                    </Button>

                    <Button
                        variant="contained"
                        onClick={savePlan}
                    >
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default EmployeeSlotPlanPage;